module.exports = __webpack_public_path__ + "img/price-quote1.9f1021a5.png";